import type { EventFilter, TelemetryEvent } from './types';

/** Runs filters in order; a drop (`false`) short-circuits and stops later filters. */
export function composeFilters<T extends TelemetryEvent>(filters: readonly EventFilter<T>[]): EventFilter<T> {
  return (event) => filters.every(filter => filter(event));
}
